let oktaAuthInstance;

export const setOktaAuth = (oktaAuth) => {
    oktaAuthInstance = oktaAuth;
};

export const getAccessToken = async () => {
    if (oktaAuthInstance) {
        return oktaAuthInstance.getAccessToken();
    }
    return null;
};

export const logout = async () => {
    oktaAuthInstance.signOut();
    sessionStorage.removeItem("appState");
};

export const renewRefreshToken = async () => {
    oktaAuthInstance.tokenManager.renew('refreshToken');
};